const PFX_CAT      = 'studio.category.';
const PFX_CREATED  = 'studio.createdAt.';
const PFX_ARCHIVED = 'studio.archived.';
const PFX_DELETED  = 'studio.deleted.';
const PFX_UNARCHIVED = 'studio.unarchived.';
const PFX_TITLE    = 'studio.title.';
const PFX_DESCRIPTION = 'studio.description.';
const PFX_STATUS   = 'studio.status.';
const KEY_OPEN     = 'studio.openCategories';
const KEY_RECENT   = 'studio.recentSlugs';

function get(key: string): string | null {
  try { return localStorage.getItem(key); } catch { return null; }
}
function set(key: string, val: string) {
  try { localStorage.setItem(key, val); } catch { /* ignore */ }
}
function remove(key: string) {
  try { localStorage.removeItem(key); } catch { /* ignore */ }
}

export const storage = {
  getCategory:  (slug: string) => get(PFX_CAT + slug),
  setCategory:  (slug: string, val: string | null) =>
    val === null ? remove(PFX_CAT + slug) : set(PFX_CAT + slug, val),

  getCreated:   (slug: string) => get(PFX_CREATED + slug),
  setCreated:   (slug: string, val: string) => set(PFX_CREATED + slug, val),

  isArchived:   (slug: string) => get(PFX_ARCHIVED + slug) === '1',
  setArchived:  (slug: string, val: boolean) => {
    if (val) { set(PFX_ARCHIVED + slug, '1'); remove(PFX_UNARCHIVED + slug); }
    else { remove(PFX_ARCHIVED + slug); set(PFX_UNARCHIVED + slug, '1'); }
  },
  isUnarchived: (slug: string) => get(PFX_UNARCHIVED + slug) === '1',

  isDeleted:    (slug: string) => get(PFX_DELETED + slug) === '1',
  setDeleted:   (slug: string, val: boolean) =>
    val ? set(PFX_DELETED + slug, '1') : remove(PFX_DELETED + slug),

  getTitle:     (slug: string) => get(PFX_TITLE + slug),
  setTitle:     (slug: string, val: string | null) =>
    !val?.trim() ? remove(PFX_TITLE + slug) : set(PFX_TITLE + slug, val.trim()),

  getDescription: (slug: string) => get(PFX_DESCRIPTION + slug),
  setDescription: (slug: string, val: string | null) =>
    val === null ? remove(PFX_DESCRIPTION + slug) : set(PFX_DESCRIPTION + slug, val.trim()),

  getStatus:    (slug: string) => get(PFX_STATUS + slug),
  setStatus:    (slug: string, val: string | null) =>
    val === null ? remove(PFX_STATUS + slug) : set(PFX_STATUS + slug, val),

  getOpenCats: (): Record<string, boolean> => {
    try {
      const raw = get(KEY_OPEN);
      return raw ? (JSON.parse(raw) as Record<string, boolean>) : { 'production-editor': true };
    } catch { return { 'production-editor': true }; }
  },
  setOpenCats: (val: Record<string, boolean>) => set(KEY_OPEN, JSON.stringify(val)),

  getRecentSlugs: (): string[] => {
    try {
      const raw = get(KEY_RECENT);
      return raw ? (JSON.parse(raw) as string[]) : [];
    } catch { return []; }
  },
  pushRecentSlug: (slug: string) => {
    try {
      const prev = storage.getRecentSlugs().filter((s) => s !== slug);
      set(KEY_RECENT, JSON.stringify([slug, ...prev].slice(0, 6)));
    } catch { /* ignore */ }
  },

};
